// SSR polyfills. Must be imported before any module that touches browser
// globals at evaluation time (e.g. the Supabase client reads localStorage
// when constructing its auth storage adapter).

function createMemoryStorage(): Storage {
  const store = new Map<string, string>();
  return {
    get length() {
      return store.size;
    },
    clear() {
      store.clear();
    },
    getItem(key: string) {
      return store.has(key) ? (store.get(key) as string) : null;
    },
    key(index: number) {
      return Array.from(store.keys())[index] ?? null;
    },
    removeItem(key: string) {
      store.delete(key);
    },
    setItem(key: string, value: string) {
      store.set(key, String(value));
    },
  };
}

const g = globalThis as unknown as {
  localStorage?: Storage;
  sessionStorage?: Storage;
};

if (typeof g.localStorage === "undefined") {
  g.localStorage = createMemoryStorage();
}
if (typeof g.sessionStorage === "undefined") {
  g.sessionStorage = createMemoryStorage();
}

export {};
